var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0776 21.91H5.3528C2.84692 21.91 0.808228 19.8713 0.808228 17.3654V8.93432C0.808228 7.42098 1.55717 6.01216 2.81147 5.16687L9.17296 0.873155C9.92301 0.364003 10.8087 0.0917969 11.7152 0.0917969C12.6217 0.0917969 13.5074 0.364003 14.2574 0.873155L20.6198 5.16687C21.2369 5.58254 21.7423 6.14358 22.0914 6.80056C22.4406 7.45754 22.6229 8.19031 22.6222 8.93432V17.3654C22.6222 19.8713 20.5835 21.91 18.0776 21.91Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b8a5e8ed042e2a5002414574512ac2ff.svg";
export { ForwardRef as ReactComponent };